import { BaseModel } from "@/models/base.model"
import { type IAddress } from "@/interfaces/api/address.interface"

export class Address extends BaseModel implements IAddress {
  public static className = "Address"
  public static verboseName = "adres"

  street?: string
  houseNumber?: string
  postalCode?: string
  country?: string

  constructor(address: IAddress) {
    super(address)

    this.street = address.street
    this.houseNumber = address.houseNumber
    this.postalCode = address.postalCode
    this.country = address.country
  }

  public clear() {
    this.street = ""
    this.houseNumber = ""
    this.postalCode = ""
    this.country = ""
  }
}
